// import React, { useRef, useEffect, useState } from "react";
import React, { Component } from "react";
import mapboxgl from "mapbox-gl";
import MapboxGeocoder from "@mapbox/mapbox-gl-geocoder";
import Legend from "./Legend";
import Optionsfield from "./Optionsfield";
import MapSelector from "./mapSelector";
import "../Map.css";
// import Tooltip from "./components/Tooltip";
import HeatTooltip from "../components/tooltips/HeatTooltip";
import ReactDOM from "react-dom";
import configData from "../config.json";
import caseStudies from "../case-studies.json";
import ShareModal from '../components/ShareModal.tsx';
import FAQModal from '../components/FAQModal.tsx';

import {  Icon, Grid, Container } from 'semantic-ui-react';

mapboxgl.accessToken =
  "pk.eyJ1IjoiZ2VvaW5zaWdodG56IiwiYSI6ImNrb3hybzJ2bTA0Z3cycHRhMG16Y2hzb2EifQ.Q_6eShFAXIFPa_rt_Pa5bw";

class Map extends Component {
  config = configData;
  styleOptions = this.config.lineStyles;

  mapTypes = this.config.baseLayer.styleOptions;
  layers = this.config.layers;
  layerGroups = this.config.layerGroups;
  sources = this.config.sources;
  effectLayerTypes = ["terrain","sky","fog","buildings"];
  state = {
    allLayersMode: true,
    activeStyle: this.styleOptions[0],
    activeMapStyle: this.mapTypes[this.config.baseLayer.selectedStyle || 0],
    layerVisibility: [],
    lng: this.config.lng,
    lat: this.config.lat,
    bearing: this.config.bearing,
    zoom: this.config.zoom,
    pitch: this.config.pitch,
    map: null,
    consentID: 0,
    cityMarker1: null,
    networkMarker1: null, 
    networkMarker2: null, 
    networkMarker3: null
  };

  mapContainerRef = React.createRef();
  tooltipRef = React.createRef();
  
  callBackMoveFn = null;
  removeLayerIfExists= (layerName ) => {
    if(this.state.map.getLayer(layerName)) {
      this.state.map.removeLayer( layerName);
    }
  };
  removeSourceIfExists = (sourceName ) => {
    
   const theLayer = this.state.map.getSource(sourceName);
   console.log (sourceName+": "+theLayer);
    if(theLayer && typeof theLayer !== 'undefined') {
      this.state.map.removeSource( sourceName);
    }
  };
  setConsentId= ( consentID ) => {
    console.log("Set Consent ID: " + consentID);

    this.removeLayerIfExists( "streams");
    this.removeLayerIfExists( "consented-stream-crossings");
    this.removeSourceIfExists( "streams");
    
    this.removeSourceIfExists( "consented-stream-crossings");
   
    if( consentID !== this.state.consentID) {
      console.log("Setting state");
      this.setState({ consentID: consentID }, () => {

        this.removeLayerIfExists( "streams");
        this.removeSourceIfExists( "streams");
        
        this.removeLayerIfExists( "consented-stream-crossings");
        this.removeSourceIfExists( "consented-stream-crossings");
       
        
        if(consentID && consentID > 0) {
          console.log("adding layers");
          this.addSource( this.state.map, "streams");
          this.addSource( this.state.map, "consented-stream-crossings");
          this.addLayer( this.state.map, "streams");
          this.addLayer( this.state.map, "consented-stream-crossings");
        }
        

      });
    }
    
  }
  transformRequest = (url, resourceType) => {

    if (resourceType === 'Source' && url.indexOf('https://api') > -1 && url.indexOf('remotehq') > -1) {
    return {
    url: this.replaceParams(url)// Include cookies for cross-origin requests
    }
    }
    };

  replaceParams = (url) => {
    console.log(url.replace('$consentNum$',this.state.consentID));
    return url.replace('$consentNum$',this.state.consentID);
    
  };
  handleMoveCallBack = ( params) => {
    // console.log(params.target);
    // const center = params.target.getCenter();
    // const zoom = params.target.getZoom();
    // console.log("Center: " + center);
    // console.log("Zoom: " + zoom);
    // this.off('moveend', this.handleMoveCallBack);

    // if(this.callBackMoveFn){
    //  // this.callBackMoveFn(feature);
    // }
    // this.callBackMoveFn = null;
  }
  printmessage = (feature) => {
    // console.log("callback for:");
    // console.log (feature);
  }
  flyTo = (...params) => {
    this.state.map.flyTo(...params);
  }
     zoomToFeature = (feature, callback) => {
    // based on this: https://www.mapbox.com/mapbox-gl-js/example/zoomto-linestring/
    // console.log("Zooming to: ")
    // console.log(feature);
    
    // Geographic coordinates of the LineString
    var geometry = feature.geometry;
    var coordinates = feature.geometry.coordinates;
    // console.log(coordinates);
    // Pass the first coordinates in the LineString to `lngLatBounds` &
    // wrap each coordinate pair in `extend` to include them in the bounds
    // result. A variation of this technique could be applied to zooming
    // to the bounds of multiple Points or Polygon geomteries - it just
    // requires wrapping all the coordinates with the extend method.
    // console.log(coordinates[0]);
    // console.log(coordinates);
  
    var bounds = null;

    this.callBackMoveFn = this.printmessage;
    this.state.map.on('moveend', this.handleMoveCallBack);
   
    if(geometry.type === "MultiPolygon") {
      
      bounds =  new mapboxgl.LngLatBounds(coordinates[0][0]._ne, coordinates[0][0]._sw);
      coordinates.forEach(polygon => {
        polygon.forEach(coords => {
        
        coords.forEach(coord => {
          
          bounds = bounds.extend(coord);
        })
      })
      });
 }
    if(geometry.type === "Polygon") {
      
       bounds =  new mapboxgl.LngLatBounds(coordinates[0][0]._ne, coordinates[0][0]._sw);
       coordinates.forEach(coords => {
       
        coords.forEach(coord => {
          
          bounds = bounds.extend(coord);
        })
      });
     
  } else if (geometry.type === "line") {
    bounds =new mapboxgl.LngLatBounds(coordinates[0], coordinates[0]);
    coordinates.forEach(coord => {
      
      bounds = bounds.extend(coord);
    })
    
  }  else if (geometry.type === "Point") {
    // console.log(coordinates)

    this.state.map.flyTo({center: coordinates, zoom: 15});
    // bounds = new mapboxgl.LngLatBounds(coordinates, coordinates);
    return {center: coordinates, zoom: 15};
  }
  //  bounds = coordinates.reduce((coord) => {
  //    console.log(coord);
  //       return bounds.extend(coord);
  //   });
  if(bounds) {

   this.zoomToBounds(bounds);
      
    return bounds;
  }
};
zoomToBounds(bounds) {

  // this.state.map.setMaxBounds(bounds);
  this.state.map.fitBounds(bounds, {
    padding: 90
  });
  this.state.map.fitBounds(bounds, {
    padding: 90
  })
};
zoomToView(view) {
  // console.log("ease to: " + view)
  this.state.map.easeTo(view);
}
  getLayerVisibility = (layerName) => {
    if(this.state.map) {
      const layer = this.state.map.getLayer(layerName);
      if(layer) {
        // console.log("Map: " + layerName);
        return this.state.map.getLayoutProperty(
          layerName,
          'visibility'
          );
      }
    };

   
    const theLayer = this.layers.find((element)  => { return element.id === layerName });
    if(theLayer !== null) {
      // console.log("Config: " + layerName);
        if(typeof theLayer.layout !== 'undefined' && typeof theLayer.layout.visibility !== 'undefined') {
          // console.log("layout.visibility: " + theLayer.layout.visibility);
        return theLayer.layout.visibility;
      }
      return 'visible';
    }
    return "?";
  };
  setLayerVisibility = (layerName, visibility) => {
    if(this.state.map !== null) {
    const layer = this.state.map.getLayer(layerName);
    var visibillityString = visibility;
    if (typeof visibility === 'boolean' || typeof visibility === 'number') {
      visibillityString = visibility ? 'visible' : 'none';
    }

    if(layer) {
      if(this.effectLayerTypes.includes(layer)) {
        if(visibillityString === 'visible' ) {
          this.addLayerIfInStyle(layer);
        } else {

        }
      } else {
        return this.state.map.setLayoutProperty(
          layerName,
          'visibility',
          visibillityString
          );
      }
      
    }
  }
  };

  hideLayer = (layerName) => {
    this.setLayerVisibility(layerName, false);
  };

  showLayer = (layerName) => {
    this.setLayerVisibility(layerName, true);
  };
  setSourceURL(sourceName, url) {
    const theSource = this.state.map.getSource(sourceName);
    
    if(theSource) {
      theSource.url = url;
    }
  }
  setSourceQueryString(source, queryString) {
    const theSource = this.state.map.getSource(source);
    var theSourceConfig = null;
    if(typeof source === 'string') {
      theSourceConfig = this.config[source];

    } else {
      theSourceConfig = source;
    }
    
    if(theSource && theSourceConfig) {
      theSource.url = theSourceConfig+"?"+queryString;
    }
  }

  addbuildings = (map, layer) => {
    map.addLayer({
      id: layer.id,
      source: "composite",
      "source-layer": "building",
      filter: layer.filter,
      type: "fill-extrusion",
      minzoom: layer.minzoom,
      paint: layer.paint
    });
  };
  addTerrain = (map, layer) => {
    //Add 3D Terrain

    map.addSource("mapbox-dem", {
      type: "raster-dem",
      url: "mapbox://mapbox.mapbox-terrain-dem-v1",
      tileSize: 512,
      maxzoom: 14
    });
    map.setTerrain({ source: "mapbox-dem", exaggeration: layer.exaggeration });
  };
  addSky = (map, layer) => {
    map.addLayer({
      id: "sky",
      type: "sky",
      paint: layer.paint
    });
  };
  addFog = (map, layer) => {
    map.setFog(layer.params);
  };
  addLayer = (map, layerConfig) => {

    if(layerConfig.id != 'regional-boundaries-line-dark' && layerConfig.id != 'regional-boundaries-line' &&  layerConfig.id != 'regional-boundaries-shade'  && layerConfig.id != 'regional-boundaries-fill'){
      if(typeof layerConfig === 'string' ) {
        layerConfig = this.layers.find((element)  => { return element.id === layerConfig });
      }
      switch (layerConfig.type) {
        case "geojson":
          this.addDataLayer(map, layerConfig);
          break;
        case "tile":
          this.addDataLayer(map, layerConfig);
          break;
        case "raster":
          this.addRasterLayer(map, layerConfig);
          break;
        case "terrain":
          this.addTerrain(map, layerConfig);
          break;
        case "sky":
          this.addSky(map, layerConfig);
          break;
        case "fog":
          this.addFog(map, layerConfig);
          break;
        case "buildings":
          this.addbuildings(map, layerConfig);
          break;
        default:
          break;
      }
      if(typeof layerConfig.click !== 'undefined') {
        console.log("Adding: " + layerConfig.click);
        
        map.on("click", layerConfig.id, e => {
          console.log("clicked");
          console.log(layerConfig.id);
          console.log(e);
          const features = e.features;
          // if (features && features.length) {
          //   const feature = features[0];
          // const features = map.queryRenderedFeatures(e.point, { layers: ['clicklayer'] });
          
          this.layerClickHandler(layerConfig.click,layerConfig.id, features);
        });
      }
        if(typeof layerConfig.rollover !== 'undefined') {
          console.log("Adding: " + layerConfig.rollover);
          map.on("mouseenter", layerConfig.id, e => {
            const features = e.features;
            // if (features && features.length) {
            //   const feature = features[0];
            // const features = map.queryRenderedFeatures(e.point, { layers: ['clicklayer'] });
            this.layerClickHandler(layerConfig.rollover,layerConfig.id, features);
            
          });
      }
      if(typeof layerConfig.cursor !== 'undefined') {
        console.log("Adding: " + layerConfig.click);
  
        map.on("mouseenter", layerConfig.id, e => {
        map.getCanvas().style.cursor = layerConfig.cursor ;
      });
        map.on("mouseleave", layerConfig.id, e => {
          map.getCanvas().style.cursor = "" ;
        });
      }
    }
  };
  layerClickHandler = (action , layerId, features) => {
    const theFunction = this.props.clickHandlers[action];
    if(typeof theFunction !== 'undefined') {
      theFunction(layerId, features[0]);
    } 
  };

  layerRolloverHandler = (action , layerId, features) => {
    console.log("Action: " + action);
    console.log("layerId: " + layerId);
    console.log(features);
  };

  addVectorLayer = (map, layerConfig) => {
    // console.log("Add Vector layer: " + layerConfig.id);
    // console.log(layerConfig);
    map.addLayer({
      id: layerConfig.id,
      type: layerConfig.dataType,
      source: layerConfig.source, // reference the data source
      paint: layerConfig.paint,
      "source-layer": layerConfig.sourcelayer || "",
      layout: layerConfig.layout
    });
  };

  addDataLayer = (map, layerConfig) => {
     map.addLayer({
      id: layerConfig.id,
      type: layerConfig.dataType,
      source: layerConfig.source,
      "source-layer": layerConfig.sourcelayer || "",
      paint: layerConfig.paint,
      layout: layerConfig.layout
    });

    if (typeof layerConfig.filter !== 'undefined') {
      // console.log("Applying filter: " + layerConfig.filter);
      // console.log("To layer: " + layerConfig.id);
      map.setFilter(layerConfig.id, layerConfig.filter);
    }
  };
  addRasterLayer = (map, layerConfig) => {
    // console.log("Add Raster layer: " + layerConfig.id);
    // console.log(layerConfig);
    map.addLayer({
      id: layerConfig.id,
      type: layerConfig.dataType,
      source: layerConfig.source,
      "source-layer": layerConfig.sourcelayer || "",
      layout: layerConfig.layout
    });
  };
  addSource = (map, source) => {
    if(typeof source === 'string' ) {
      source = this.sources.find((element)  => { return element.id === source });
    }
    // console.log("Add source: " + source.id);
    // console.log(source);
    if(source.mode && source.mode !== this.props.mode ) {

    } else {
      if (source.tiles) {
        map.addSource(source.id, {
          type: source.type,
          tiles: source.tiles,
          minzoom: typeof source.minzoom === "undefined" ? 0 : source.minzoom,
          maxzoom: typeof source.maxzoom === "undefined" ? 22 : source.maxzoom
        });
      } else {
        map.addSource(source.id, {
          type: source.type,
          data: source.url
        });
      }
    }
  };
  setFilter = (layerId, filter) => {
    if(this.state.map && this.state.map.getLayer(layerId)) {
      this.state.map.setFilter(layerId,filter);
    }
  }
  addControl = (map, control) => {
    switch (control.type) {
      case "geocoder":
        map.addControl(
          new MapboxGeocoder({
            accessToken: mapboxgl.accessToken,
            mapboxgl: mapboxgl,
            countries: control.countries,
            placeholder: "search for an address",
          })
        );
        break;
      case "navigation":
        map.addControl(new mapboxgl.NavigationControl(), control.position);
        break;
      default:
        break;
    }
  };
  addUI = map => {
    // Add Mapbox controls

    this.config.controls.map(control => {
      return this.addControl(map, control);
    });

    // add sources
    this.config.sources.map(source => {
      return this.addSource(map, source);
    });

    // Add Layers
    this.config.layers.map(layer => {
      return this.addLayerIfInStyle(map, layer);
    });
    // this.changeStyleState(0);
    // set wastewater style - should not be hard coded - but in for demo

    map.on("move", () => {
      this.setState({ lng: map.getCenter().lng.toFixed(4) });
      this.setState({ lat: map.getCenter().lat.toFixed(4) });
      this.setState({ zoom: map.getZoom().toFixed(2) });
      // this.setState({ pitch: map.getCameraPosition().tilt.toFixed(2) });
      // console.log(
      //   "Lat: " +
      //     map.getCenter().lng +
      //     " " +
      //     "Long: " +
      //     map.getCenter().lat +
      //     " Zoom: " +
      //     map.getZoom()
      // );
    });

   

    // reset cursor to default when user is no longer hovering over a clickable feature
    // map.on("mouseleave", "clicklayer", () => {
    //   map.getCanvas().style.cursor = "";
    // });

    // add tooltip when users mouse move over a point
    // map.on("mouseleave", "wastewater", e => {
    //   this.tooltipRef.current.remove();
    // });
    map.on("click", "clicklayer", e => {
      // console.log(e.features);
      // console.log(e.features[0]);
      // const features = map.queryRenderedFeatures(e.point);
      const features = e.features;
      if (features && features.length) {
        const feature = features[0];

        // Create tooltip node
        const tooltipNode = document.createElement("div");

        ReactDOM.render(<HeatTooltip feature={feature} key={feature.id} />, tooltipNode);

        // Set tooltip on map
        this.tooltipRef.current
          .setLngLat(e.lngLat)
          .setDOMContent(tooltipNode)
          .addTo(map);
      }
    });
    map.on("style.load", () => {
      console.log("Map style load");
      // Triggered when `setStyle` is called.
      // console.log("on style load");
      this.config.sources.map(source => {
        return this.addSource(map, source);
      });
      this.config.layers.map(layer => {
        return this.addLayerIfInStyle(map, layer);
      });
      this.setStyleGroup();
      
    });
  };

  addLayerIfInStyle = (map, layer) => {
    if(typeof layer === 'string' ) {
      layer = this.layers.find((element)  => { return element.id === layer });
    }
    // check layer is within the list of layers the style will show.
    if(this.state.allLayersMode && !this.effectLayerTypes.includes(layer.type) ) {
      this.addLayer(map, layer);
    } else {

      const index = this.state.activeMapStyle.layers.indexOf(layer.id);
      if (index >= 0) {
        this.addLayer(map, layer);
      }
    }
  };
  setStyle = (style) => {
    // console.log(style);
    if (this.state.map && this.state.map.getLayer(style.layer)) {
      this.state.map.setPaintProperty(
        style.layer,
        style.paint,
        {
          property: style.property,
          stops: style.stops
        }
      );
    }
  };
  setStyleGroup = () => {
    if (typeof this.state.map !== 'undefined') {

      this.state.activeStyle.styles.map((style) => {

        return this.setStyle(style);
      });
      this.props.callbacks.mapIsLoaded();
      // this.state.map.setStyle(
      //   "wastewater",

      //   this.state.activeLineStyle.paint,
      //   {
      //     property: this.state.activeLineStyle.property,
      //     stops: this.state.activeLineStyle.stops
      //   }
      // );
      // console.log("Active: ", this.state.activeLineStyle);
      // if (this.state.activeLineStyle.paint === "line-width") {
      //   console.log("Single Color");
      //   this.state.map.setPaintProperty("wastewater", "line-color", "#ff0000");
      // } else {
      //   this.state.map.setPaintProperty("wastewater", "line-width", 3);
      // }
    }
  };

  paint = () => {
    this.setStyleGroup();
  };
  getViewParams = () => {
    if (typeof this.state.map !== 'undefined' && this.state.map) {
        const zoom = this.state.map.getZoom();
        const {lng, lat} = this.state.map.getCenter();
        console.log(this.state.map.getCenter())
        const pitch = this.state.map.getPitch();
        const bearing = this.state.map.getBearing();
        const viewParams = {lng: parseInt(lng * 1000000) / 1000000, lat:  parseInt(lat * 1000000) / 1000000, zoom: parseInt(zoom*100) / 100, pitch: parseInt( pitch *10) / 10 ,  bearing: parseInt(bearing*10 ) / 10 };
        return viewParams;
    }
    return {};
}
  changeStyleState = i => {
    this.setState({ activeStyle: this.styleOptions[i] }, () => {
      this.setStyleGroup();
    });
  };
  changeMapState = i => {
    this.setState({ activeMapStyle: this.mapTypes[i] }, () => {
      if (this.state.map.getLayer("wastewater")) {
        // console.log("Found layer, removing");
        this.state.map.removeLayer("wastewater");
      }

      this.state.map.setStyle(
        "mapbox://styles/mapbox/" + this.mapTypes[i].mapStyle
      );
    });
  };

  //function for change marker colors
  setMarker = (name, type, color) => {
    return '<svg type="'+type+'" name="'+name+'" display="block" height="41px" width="27px" viewBox="0 0 27 41"> <g fill="'+color+'" type="'+type+'" name="'+name+'"> <path type="'+type+'" name="'+name+'" d="M27,13.5 C27,19.074644 20.250001,27.000002 14.75,34.500002 C14.016665,35.500004 12.983335,35.500004 12.25,34.500002 C6.7499993,27.000002 0,19.222562 0,13.5 C0,6.0441559 6.0441559,0 13.5,0 C20.955844,0 27,6.0441559 27,13.5 Z"></path> </g> <g type="'+type+'" name="'+name+'" transform="translate(8.0, 8.0)"> <circle type="'+type+'" name="'+name+'" fill="#FFFFFF" cx="5.5" cy="5.5" r="5.4999962"></circle> </g></svg>';;
  };
  
  // function adds case study markers to the map
  addCaseStudy = () => {
    let map = this.state.map;
    let self = this;
    //get features from Json object
    let features = caseStudies['features'];

    //loop for adding markers
    Object.keys(features).forEach(function(key) {
      
      let markerData = features[key];

      let color = markerData.properties['marker-color'];
      let markerSize = 'fa-4x';
      if(markerData.properties['marker-size'] ){
        markerSize = markerData.properties['marker-size'] === 'small' ?  'fa-3x' : markerData.properties['marker-size'] === 'medium' ? 'fa-4x' : markerData.properties['marker-size'] === 'large' && 'fa-5x';
      }
      
      let name = markerData.properties['Name'];
      let link = markerData.properties['link'];
      let type = markerData.properties['Type'];

      //define pop up
      const popup = new mapboxgl.Popup({ offset: 25 }).setText(
        'Construction on the Washington Monument began in 1848.'
      );

      //create pop up html
      const el = document.createElement('div');
      el.innerHTML = self.setMarker(name, type, color);
      el.id = 'marker'+name;
      
      if(type == 'Case Study'){

        let description = '<div style=padding:10px;><b>Name : </b>'+name+'<br />';
        description += '<b>Type : </b>'+type;
        description += '<br /><b>Link : </b><span style=word-wrap:break-word;>'+link+'</span>';
        description += '</div><div style=text-align:center;><b><a target="__blank" href='+link+' >Click here...</a></b></div>'

        //set pop up
        popup.setLngLat(markerData.geometry.coordinates)
        .setHTML(description)
        .addTo(map);


        // set Case Study markers
        new mapboxgl.Marker(el)
        .setLngLat(markerData.geometry.coordinates)
        .setPopup(popup) // sets a popup on this marker
        .addTo(map);
      }else{

        // set Network markers
        var oneMarker = new mapboxgl.Marker(el)
        .setLngLat(markerData.geometry.coordinates)
        .addTo(map);

        //listen to the marker click event
        oneMarker.getElement().addEventListener('click', (e) => {
          const name = e.target.getAttribute("name");
          const type = e.target.getAttribute("type");
          if(type == 'Network'){
            const currentdata = features.filter( (data) => data.properties.Name === name);
            map.setZoom(11); 
            map.setCenter(currentdata[0].geometry.coordinates);
            
          }
        });
      }
    });
  }

  componentDidMount() {
    // console.log(this.config.baseLayer.styleOptions.selectedStyle);
    this.tooltipRef.current = new mapboxgl.Popup({ offset: 15, maxWidth: 'none' });
    
    const map = new mapboxgl.Map({
      container: this.mapContainerRef.current,
      style: "mapbox://styles/mapbox/" + this.state.activeMapStyle.mapStyle, // Dark: /dark-v10, Outdoors: /outdoors-v11, Street: /streets-v11 , Satellite: satellite-v9
      center: [this.state.lng, this.state.lat],
      bearing: this.state.bearing,
      zoom: this.state.zoom,
      pitch: this.state.pitch,
      transformRequest: this.transformRequest
    });
    map.showTerrainWireframe = this.config.wireframe || false;
    this.setState({ map: map });
    map.on("load", () => {
      console.log("about to callback to mapIsLoaded: ", this.props.callbacks);
      this.props.callbacks.mapIsLoaded();
      this.addCaseStudy();
      this.addUI(map);
    });
    map.on('zoomend', () => {
      if(this.state.map.getZoom() >= 6){
        document.getElementsByClassName("legends-box")[0].style.display = "block";
      }
      else{
        document.getElementsByClassName("legends-box")[0].style.display = "none";
      }
    });
    this.props.callbacks.setLayers(this.layers);
    this.props.callbacks.setLayerGroups(this.layerGroups);
    this.props.callbacks.setMapStyleOptions(this.mapTypes);
    this.setState({isLoaded: 1});
  }
  setMaxBounds(bounds) {
    console.log("setting max bounds");
    if(this.state.map) {
      
      console.log(bounds);
      // this.state.map.setMaxBounds(bounds);
    }
  }
  componentWillUnmount() {
    if(this.map) {
      this.map.remove();
    }
  }

  generateControl(control, i) {

    let classes = "absolute m12";
    if (control.hasOwnProperty("position")) {
      control.position.map(arg => {
        classes = classes + " " + arg;
        if(arg === "bottom") {
          classes = "absolute " + classes;
        }
        return classes;
      });
    }

    switch (control.type) {

      case "legend":
        if (typeof this.state.activeStyle.labels !== 'undefined') {


          return (
            <div key={control.id} className={classes}>
              <Legend
                active={this.state.activeStyle}
                labels={this.state.activeStyle.labels}
              />
            </div>
          );
        }
        break;

      case "options":
        return (
          <div key={control.id} className={classes}>
            <Optionsfield
              options={this.styleOptions}
              property={this.state.activeStyle.id}
              changeState={this.changeStyleState}
            />
          </div>
        );

      case "maptiles":
        return (
          <div key={control.id} className={classes}>
            <MapSelector
              options={this.mapTypes}
              property={this.state.activeMapStyle.mapStyle}
              changeState={this.changeMapState}
            />
          </div>
        );

      default:
        return <></>;
    }
  }
  loadDefaultMap = (layerId, feature) => {
    let map = this.state.map;
    map.setCenter([ 34,  18])
    map.setZoom(1.31);
  }

  render() {
    return (
      <div>
        <div className='menu_container'>
          <button onClick={()=>this.loadDefaultMap(null, null)} className='home_button buttons'><Icon name="home" size="large"></Icon></button>
          <FAQModal></FAQModal>
        </div>
        <div ref={this.mapContainerRef} className="map-container" />
        {this.config.controls.map((control, i) => { return this.generateControl(control, i) }, this)}
      </div>
    );
  }
}

export default Map;
